import type { Transaction } from '@shared/transactions-types';
import { t } from '@luna/i18n';

import { hasRoundingDonation } from '../../predicates/hasRoundingDonation';

export const getRoundingLabel = (transaction: Transaction): string => {
    if (hasRoundingDonation(transaction)) {
        return t('transaction.roundingupdonation');
    }

    return t('transaction.roundingupsaving');
};
